import {Action} from '@ngrx/store';
import {Events, EventsParams, FilterParams} from '../../models/events';


// define action types
export const enum EventsTypes {
  GET_EVENTS = '[events] GET_EVENTS',
  GET_EVENTS_SUCCESS = '[events] GET_EVENTS_SUCCESS',
  GET_EVENTS_FAIL = '[events] GET_EVENTS_FAIL',
  GET_EVENTS_FILTER_PARAMS = '[events-params]  GET_EVENTS_FILTER_PARAMS'
}

// define Actions class

export class GetEventAction implements Action {
  readonly type = EventsTypes.GET_EVENTS;

  constructor(public payload: EventsParams = null) {
  }
}

export class GetEventsSuccessAction implements Action {
  readonly type = EventsTypes.GET_EVENTS_SUCCESS;

  constructor(public payload: Events[] = null) {
  }
}

export class GetEventFailAction implements Action {
  readonly type = EventsTypes.GET_EVENTS_FAIL;

  constructor(public payload: any = null) {
  }
}

export class GetEventFilterParams implements Action {
  readonly type = EventsTypes.GET_EVENTS_FILTER_PARAMS;

  constructor(public payload: FilterParams = null) {
  }
}


export type EventsActions
  = GetEventAction
  | GetEventsSuccessAction
  | GetEventFailAction
  | GetEventFilterParams;
